export default "__VITE_ASSET__mzW5nyoz__"